import React, { Component } from "react";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";
import "../build/css/gestor.css";
import Moment from "moment";
import * as htmlToImage from "html-to-image";
import { PopoverDashboard } from "./../actions/Tippy";

import { ReactComponent as ShareIcon } from "../build/images/share-manager.svg";
import { ReactComponent as DownloadIcon } from "../build/images/document-download.svg";
import { ReactComponent as FilterIcon } from "../build/images/icons/filtermail.svg";
import { ReactComponent as CleanIcon } from "../build/images/clean-icon-red.svg";
import { ReactComponent as CategoryIcon } from "../build/images/categorymanager.svg";
import { ReactComponent as CallIcon } from "../build/images/iconcalltwo.svg";
import { ReactComponent as MessageIcon } from "../build/images/iconmessagetwo.svg";
import { ReactComponent as ChatIcon } from "../build/images/iconchart.svg";
import { ReactComponent as MonitoringIcon } from "../build/images/status-up.svg";
import { clearFiltersManager } from "../actions";
import ChatSimultComponent from "../containers/ChatSimult";

import CardSimple from "./manager-section/CardsComponent/CardSimple";
import CardStatusOperators from "./manager-section/CardsComponent/CardStatusOperators";
import CardPerfomance from "./manager-section/CardsComponent/CardPerfomance";
import CardClientAnswer from "./manager-section/CardsComponent/CardClientAnswer";
import CardPreferredIntentions from "./manager-section/CardsComponent/CardPreferredIntentions";
import CardQueue from "./manager-section/CardsComponent/CardQueue";
import CardAbandonment from "./manager-section/CardsComponent/CardAbandonment";
import CardTableService from "./manager-section/CardsComponent/CardTableService";
import CardTableColaborator from "./manager-section/CardsComponent/CardTableColaborator";
import TextMedium from "./manager-section/TextComponent/TextMedium";
import Drawer from "./mail-section/Drawer";
import CardLevelProgress from "./manager-section/CardsComponent/CardLevelProgress";
import CardChannelVoz from "./manager-section/CardsComponent/CardChannelVoz";
import CardChannelDigital from "./manager-section/CardsComponent/CardChannelDigital";
import CardTotalConnected from "./manager-section/CardsComponent/CardTotalConnected";
import CardTableOperatorsManager from "./manager-section/CardsComponent/CardTableOperatorsManager";
import Manager from "./Manager";
import QueueSlim from "../containers/QueueSlim";
import Queue from "../containers/Queue";
import CardTimeRow from "./manager-section/CardsComponent/CardTimeRow";
import CardTableGroupRow from "./manager-section/CardsComponent/CardTableGroupRow";
import { connection_platform } from "../services/api";

let jsonSRV = [];
let valorNSFinal = 0;
let valorCAFinal = 0;
let timeOfAverage = [];
let timeOfAbandoned = [];
let desempenhoAtd = 0;
let url_iframe = "";

let atendidas = 0;
let desempenhoRec = 0;
let desempenhoCurtas = 0;
let desempenhoAtdOutSLA = 0;
let desempenhonsservico = 0;
let timeAverageAbandoned = 0;
let timeAverageQtdAbandoned = 0;
let timeAveragePercentAbandoned = 0;
let timeAverageQueue = 0;
let timeAverageMidleAnswer = 0;
let timeAverageQueueMax = 0;
let desempenhoTmpABDN = 0;
let desempenhoAbdn = 0;
let desempenhoTmpAtd = 0;
let desempenhoTmpFila = 0;
let desempenhoqtdFila = 0;
let desempenhoMAXTME = 0;
let TimeFormat = require("hh-mm-ss");
let maxcallqueue = 0;
let maxcallqueueFormat = 0;
let cdrmaxcallqueue = 0;
let jsonQueueMax = [];

const mapStateToProps = (state) => {
  return {
    ServiceGroup: state.servicegroup,
    QueueReducer: state.listcallqueue,
    IPCurrent: state.ipcurrent,
    FilterManager: state.filtersmanager,
    User: state.informationusers,
    ServiceURL: state.serviceurl,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearFiltersManagerReduce: () => {
      dispatch(clearFiltersManager());
    },
  };
};

class ManagerNew extends Component {
  constructor(props) {
    super(props);
    //lógica aqui
    let modeStorage = localStorage.getItem("manager__mode-screen");
    const hasModeStorageInAnalyticalViewsAllowed =
      connection_platform.analyticalViewsAllowed.includes(
        parseInt(modeStorage)
      );

    if (
      !hasModeStorageInAnalyticalViewsAllowed &&
      connection_platform.analyticalViewsAllowed.length > 0
    ) {
      localStorage.setItem(
        "manager__mode-screen",
        connection_platform.analyticalViewsAllowed[0]
      );
      modeStorage = connection_platform.analyticalViewsAllowed[0];
    }

    let modeTabShit = "services";
    if (localStorage.getItem("manager__tabshit-mode")) {
      modeTabShit = localStorage.getItem("manager__tabshit-mode");
    }
    if (!connection_platform.isServiceTabActive && modeTabShit === "services") {
      localStorage.setItem("manager__tabshit-mode", "teams");
      modeTabShit = "teams";
    }
    this.state = {
      modeScreen: modeTabShit,
      isVisibleDrawer: false,
      mode: modeStorage ? parseInt(modeStorage) : 1,
    };
  }

  setVisibleDrawer(bind) {
    bind.setState({ isVisibleDrawer: false });
  }

  handleDashboard(mode) {
    this.setState({ mode: mode });
    localStorage.setItem("manager__mode-screen", mode);
    document.getElementById("simulation_click").click();
  }

  handleTabShit(mode) {
    this.setState({ modeScreen: mode });
    if (mode !== "ingdesk") {
      localStorage.setItem("manager__tabshit-mode", mode);
    }
  }

  renderHandleDashboard = () => (
    <div className="popover__dashboard-screen">
      {connection_platform.analyticalViewsAllowed.includes(1) && (
        <div
          onClick={(event) => this.handleDashboard(1)}
          className={
            this.state.mode === 1
              ? "popover__dashboard-screen__labels enable"
              : "popover__dashboard-screen__labels"
          }
        >
          <li>
            <MessageIcon />
          </li>
          <li>
            <strong>Visão analítica 1</strong>
            <span>Foco na qualidade do atendimento.</span>
          </li>
        </div>
      )}
      {connection_platform.analyticalViewsAllowed.includes(2) && (
        <div
          onClick={(event) => this.handleDashboard(2)}
          className={
            this.state.mode === 2
              ? "popover__dashboard-screen__labels enable"
              : "popover__dashboard-screen__labels"
          }
        >
          <li>
            <CallIcon />
          </li>
          <li>
            <strong>Visão analítica 2</strong>
            <span>
              Mais focado para quem quer ver canais digitais e voz,
              individualmente.
            </span>
          </li>
        </div>
      )}
      {connection_platform.analyticalViewsAllowed.includes(3) && (
        <div
          onClick={(event) => this.handleDashboard(3)}
          className={
            this.state.mode === 3
              ? "popover__dashboard-screen__labels enable"
              : "popover__dashboard-screen__labels"
          }
        >
          <li>
            <ChatIcon />
          </li>
          <li>
            <strong>Visão analítica 3</strong>
            <span>Foco no detalhamento da fila.</span>
          </li>
        </div>
      )}

      {connection_platform.analyticalViewsAllowed.includes(4) && (
        <div
          onClick={(event) => this.handleDashboard(4)}
          className={
            this.state.mode === 4
              ? "popover__dashboard-screen__labels enable"
              : "popover__dashboard-screen__labels"
          }
        >
          <li>
            <MonitoringIcon
              className={"popover__dashboard-screen__icon"}
              width={16}
              height={16}
            />
          </li>
          <li>
            <strong>Visão analítica 4</strong>
            <span>Foco na monitoração do atendimento.</span>
          </li>
        </div>
      )}
    </div>
  );

  onDownload() {
    if (this.state.modeScreen !== "ingdesk") {
      const element = document.querySelector("#alldata");
      const sectionTable = document.querySelector(".manager-container__area");

      sectionTable.classList.replace(
        "manager-container__area",
        "manager-container__area_before"
      );
      //document.getElementById("border-line-container").style.display = "none";

      htmlToImage
        .toPng(element, {
          height: sectionTable.clientHeight + 150,
        })
        .then(function (dataUrl) {
          const a = document.createElement("a");
          a.download = "file.png";
          a.href = dataUrl;
          a.click();
          sectionTable.classList.replace(
            "manager-container__area_before",
            "manager-container__area"
          );
          // document.getElementById("border-line-container").style.display =  "block";
        })
        .catch(function (error) {
          console.error("oops, something went wrong!", error);
          sectionTable.classList.replace(
            "manager-container__area_before",
            "manager-container__area"
          );
          //document.getElementById("border-line-container").style.display ="block";
        });
    } else {
      const element = document.querySelector("#alldata");
      const sectionTable = document.querySelector(
        "manager-container__iframe-ingdesk"
      );

      // sectionTable.classList.replace("manager-container__area", "manager-container__area_before");
      //document.getElementById("border-line-container").style.display = "none";

      htmlToImage
        .toPng(element, {
          height: "1400",
        })
        .then(function (dataUrl) {
          const a = document.createElement("a");
          a.download = "file.png";
          a.href = dataUrl;
          a.click();
          // sectionTable.classList.replace("manager-container__area_before", "manager-container__area");
          //document.getElementById("border-line-container").style.display = "block";
        })
        .catch(function (error) {
          console.error("oops, something went wrong!", error);
          // sectionTable.classList.replace("manager-container__area_before", "manager-container__area");
          //document.getElementById("border-line-container").style.display ="block";
        });
    }
  }

  clearFiltersManager() {
    this.props.clearFiltersManagerReduce();
    localStorage.removeItem("managernew_filter_group");
    localStorage.removeItem("managernew_filter_status");
    localStorage.removeItem("managernew_filter_service");
    localStorage.removeItem("managernew_filter_channel");
  }

  render() {
    const { modeScreen, isVisibleDrawer, mode } = this.state;
    const {
      ServiceGroup,
      QueueReducer,
      IPCurrent,
      FilterManager,
      User,
      ServiceURL,
    } = this.props;

    if (ServiceGroup && ServiceGroup.length !== 0 && FilterManager.is_active) {
      desempenhoAtd = 0;
      desempenhoTmpAtd = 0;

      atendidas = 0;
      desempenhoRec = 0;
      desempenhoCurtas = 0;
      desempenhoAtdOutSLA = 0;
      desempenhonsservico = 0;
      timeAverageAbandoned = 0;
      timeAverageQtdAbandoned = 0;
      timeAveragePercentAbandoned = 0;
      timeAverageQueue = 0;
      timeAverageMidleAnswer = 0;
      timeAverageQueueMax = 0;
      desempenhoTmpABDN = 0;
      desempenhoAbdn = 0;
      desempenhoTmpAtd = 0;
      desempenhoTmpFila = 0;
      desempenhoqtdFila = 0;
      desempenhoMAXTME = 0;
      TimeFormat = require("hh-mm-ss");
      maxcallqueue = 0;
      maxcallqueueFormat = 0;
      cdrmaxcallqueue = 0;
      jsonQueueMax = [];

      jsonSRV = JSON.parse(ServiceGroup.json);
      jsonSRV = jsonSRV.filter((filt) =>
        FilterManager.filter_manager_service.includes(filt.idgrupo)
      );
      jsonSRV = jsonSRV.filter((filt) =>
        FilterManager.filter_manager_channel.includes(filt.idmidia)
      );
      //console.log("jsonSRV", jsonSRV);
      Object.keys(jsonSRV).map((group) => {
        atendidas += jsonSRV[group].qtde_atendidas;
        desempenhoRec += jsonSRV[group].qtde_recebidas;
        desempenhoAtd += jsonSRV[group].qtde_atendidas;
        desempenhoCurtas += jsonSRV[group].qtde_abandonada_sla;
        desempenhoAtdOutSLA += jsonSRV[group].qtde_atendida_fora_sla;
        desempenhonsservico = jsonSRV[group].percentual_ns;
        desempenhoAbdn += jsonSRV[group].qtde_abandonada;
        desempenhoTmpABDN += jsonSRV[group].duracao_abandonada_fila;
        desempenhoTmpAtd += jsonSRV[group].duracao_atendidas;
        desempenhoTmpFila += jsonSRV[group].duracao_fila;
        desempenhoqtdFila += jsonSRV[group].qtde_fila_atd;

        if (jsonSRV[group].duracao_maxima_fila > desempenhoMAXTME)
          desempenhoMAXTME = jsonSRV[group].duracao_maxima_fila;
      });

      valorNSFinal =
        desempenhoAtd > 0
          ? ((parseInt(desempenhoAtd) - parseInt(desempenhoAtdOutSLA)) /
              (parseInt(desempenhoRec) - parseInt(desempenhoCurtas)) /
              desempenhonsservico) *
            100
          : 0;
      valorNSFinal = valorNSFinal > 100 ? 100 : valorNSFinal;
      valorCAFinal =
        desempenhoRec > 0
          ? ((desempenhoAtd / desempenhoRec) * 100).toFixed(2)
          : 0;

      timeAverageAbandoned = TimeFormat.fromS(
        desempenhoTmpABDN > 0 && parseInt(desempenhoAbdn) > 0
          ? parseInt(parseInt(desempenhoTmpABDN) / parseInt(desempenhoAbdn))
          : 0,
        "hh:mm:ss"
      );
      timeAverageQtdAbandoned = desempenhoAbdn;
      timeAveragePercentAbandoned = (
        (desempenhoAbdn / desempenhoRec) *
        100
      ).toFixed(2);
      timeAverageQueue = TimeFormat.fromS(
        desempenhoTmpFila > 0
          ? parseInt(parseInt(desempenhoTmpFila) / parseInt(desempenhoqtdFila))
          : 0,
        "hh:mm:ss"
      );
      timeAverageQueueMax = TimeFormat.fromS(
        desempenhoMAXTME > 0 ? parseInt(desempenhoMAXTME) : 0,
        "hh:mm:ss"
      );
      timeAverageMidleAnswer = TimeFormat.fromS(
        desempenhoTmpAtd > 0
          ? parseInt(parseInt(desempenhoTmpAtd) / parseInt(desempenhoAtd))
          : 0,
        "hh:mm:ss"
      );

      timeOfAverage = [
        ,
        {
          time: timeAverageQueueMax !== 0 ? timeAverageQueueMax : "00:00:00",
          hint: "Maior tempo de espera para atendimento",
          title: "M.T.E. Atendimento",
          titleSmall: "M.T.E.A",
        },
        {
          time: timeAverageQueue !== 0 ? timeAverageQueue : "00:00:00",
          hint: "Tempo médio de espera para atendimento",
          title: "T.M.E. Atendimento",
          titleSmall: "T.M.E.A",
        },
      ];

      timeOfAbandoned = [
        {
          time: timeAverageQtdAbandoned,
          hint: "Quantidade de abandonos",
          title: "Qtd. abandonos",
        },
        {
          time: timeAverageAbandoned !== 0 ? timeAverageAbandoned : "00:00:00",
          hint: "Tempo médio de abandono",
          title: "T.M. de Abandono",
        },
      ];
    }

    if (ServiceURL.length !== 0) {
      let ArrayServiceURL = "";
      if (User.nameauth === "IngDesk") {
        ArrayServiceURL = ServiceURL.filter(
          (url) => url.typeofcrm === "IngDesk"
        );
        if (ArrayServiceURL.length !== 0) {
          url_iframe = ArrayServiceURL[0].param;
        }
      }
    }

    if (QueueReducer.length !== 0) {
      QueueReducer.map((queue) => {
        if (parseInt(queue.status) === 1) {
          if (
            Moment(queue.to_char, "DD/MM/YYYY HH:mm:ss").format(
              "DD/MM/YYYY HH:mm:ss"
            ) < maxcallqueue ||
            maxcallqueue === 0
          ) {
            maxcallqueue = Moment(queue.to_char, "DD/MM/YYYY HH:mm:ss").format(
              "DD/MM/YYYY HH:mm:ss"
            );
            maxcallqueueFormat = Moment(
              queue.to_char,
              "DD/MM/YYYY HH:mm:ss"
            ).format("YYYY/MM/DD HH:mm:ss");
            var now;
            var antes;
            var duracao = 0;
            var checkItem = false;

            if (IPCurrent.difftime < 0) {
              antes = maxcallqueueFormat;
              now = Moment()
                .add(Math.round(IPCurrent.difftime), "seconds")
                .format("YYYY/MM/DD HH:mm:ss");
              duracao = Moment(now).diff(antes, "seconds");
              checkItem = true;
            } else {
              antes = maxcallqueueFormat;
              now = Moment()
                .subtract(Math.round(IPCurrent.difftime), "seconds")
                .format("YYYY/MM/DD HH:mm:ss");
              duracao = Moment(now).diff(antes, "seconds");
              checkItem = true;
            }

            jsonQueueMax = [
              {
                queuePathFile: queue.pathfile,
                queueMediaid: queue.mediaid,
                queueContactname: queue.contactname,
                queueCaller: queue.caller,
                queueQueueid: queue.queueid,
                queueScriptid: queue.scriptid,
                queueCdrid: queue.cdrid,
                queueGeral: queue,
                queueCalled: queue.called,
                queueRecv_count: queue.recv_count,
                queueObs: queue.obs,
                queueCallback_count: queue.callback_count,
                queueDurationQueue: duracao,
              },
            ];
          }
        }
      });
    }

    let totalFilters =
      FilterManager.filter_manager_channel.length +
      FilterManager.filter_manager_status.length +
      FilterManager.filter_manager_service.length +
      FilterManager.filter_manager_group.length +
      FilterManager.filter_manager_grouprow.length;

    return (
      <div
        className="manager-container responsive"
        id="alldata"
        ref={(el) => (this.componentRef = el)}
      >
        <div className="manager-container__header">
          <div className="manager-container__header-title">
            <span className="manager-container__header-title__text">
              Dashboard
            </span>
          </div>
          <div className="manager-container__header-actions">
            <ul className="manager-container__screens__list">
              {modeScreen === "ingdesk" && (
                <div className="invisible-ingdesk"></div>
              )}
              {modeScreen !== "ingdesk" && (
                <PopoverDashboard
                  trigger="click"
                  boundary="window"
                  placement="bottom"
                  multiple={true}
                  interactive={true}
                  content={this.renderHandleDashboard(this)}
                >
                  <li>
                    <CategoryIcon />
                  </li>
                </PopoverDashboard>
              )}
              {/* <li>
                    <ShareIcon />
                  </li> 
              */}
              {modeScreen !== "ingdesk" && (
                <li onClick={() => this.onDownload()}>
                  <DownloadIcon />
                </li>
              )}
              {modeScreen !== "ingdesk" && (
                <>
                  <li>
                    <button
                      className="manager-container__header__actions-filter"
                      onClick={(event) =>
                        this.setState({ isVisibleDrawer: true })
                      }
                    >
                      <FilterIcon />
                      Filtros
                      {totalFilters > 0 && (
                        <div className="manager-container__header__actions-filter__legend">
                          <span>{totalFilters}</span>
                        </div>
                      )}
                    </button>
                  </li>
                  {totalFilters > 0 && (
                    <button
                      className="drawer__div__footer-btn-terciary"
                      onClick={() => this.clearFiltersManager()}
                    >
                      <CleanIcon />
                      Limpar Filtros
                    </button>
                  )}
                </>
              )}
            </ul>
          </div>
        </div>
        <div className="manager-container__screens">
          <ul className="manager-container__screens__list">
            {mode !== 3 && (
              <>
                {connection_platform.isServiceTabActive && (
                  <li
                    className={`page-change ${
                      modeScreen === "services" ? "active" : ""
                    }`}
                    onClick={(event) => this.handleTabShit("services")}
                  >
                    <TextMedium
                      text="Serviços"
                      color={modeScreen === "services" ? "blue" : "gray400"}
                    />
                  </li>
                )}
                <li
                  className={`page-change ${
                    modeScreen === "teams" ? "active" : ""
                  }`}
                  onClick={(event) => this.handleTabShit("teams")}
                >
                  <TextMedium
                    text="Equipes"
                    color={modeScreen === "teams" ? "blue" : "gray400"}
                  />
                </li>
                {/* <li onClick={event => this.handleTabShit("ingdesk")}>
                <TextMedium text="CRM - IngDesk" color={modeScreen === "ingdesk" ? "blue":"gray400"} />
              </li> */}
              </>
            )}
            {User.nameauth === "IngDesk" && mode !== 3 && (
              <>
                <li
                  className={`page-change ${
                    modeScreen === "ingdesk" ? "active" : ""
                  }`}
                  onClick={(event) => this.handleTabShit("ingdesk")}
                >
                  <TextMedium
                    text="CRM - IngDesk"
                    color={modeScreen === "ingdesk" ? "blue" : "gray400"}
                  />
                </li>
              </>
            )}
            {/* <li onClick={event => this.setState({modeScreen: "selfservice"})}>
              <TextMedium text="Autoatendimento" color={modeScreen === "selfservice" ? "blue":"gray400"} />
            </li> */}
          </ul>
          <hr className="border-line" style={{ opacity: "40%" }}></hr>
          {/* <div id="border-line-container">
          {mode !== 3 && 
            <>
            {modeScreen === "services" && <div className="selector-service"></div>}
            {modeScreen === "teams" && <div className="selector-team"></div>}
            {modeScreen === "selfservice" && <div className="selector-self"></div>}
            {modeScreen === "ingdesk" && <div className="selector-ingdesk"></div>}
            </>
          }
          </div> */}
        </div>
        {modeScreen === "ingdesk" && (
          <div className="manager-container__iframe-ingdesk">
            <iframe
              frameBorder="0"
              allow="camera;microphone;clipboard-write"
              src={`${url_iframe}/externo/dashboard?login-master=ingenium&login-user=${User.username}&password-master=52e9f8a1500604b372a5c0908d93ee5f`}
              style={{ height: "100%", width: "100%" }}
              name="iframe_a"
              title="Iframe Example"
              id="container_ingdesk_iframe"
            ></iframe>
          </div>
        )}
        {modeScreen !== "ingdesk" && (
          <>
            {(mode === 1 || (mode === 4 && modeScreen === "services")) && (
              <div className="manager-container__area responsive">
                <CardLevelProgress
                  title="Nível de Serviço"
                  level={valorNSFinal}
                />
                <div className="manager-container__row-one responsive">
                  <CardClientAnswer
                    classname="interations-graph responsive__item"
                    title="Interações"
                    timeAverageMidleAnswer={timeAverageMidleAnswer}
                    level={Math.round(valorCAFinal)}
                    desempenhoRec={desempenhoRec}
                    atendidas={atendidas}
                    timeAverageQtdAbandoned={timeAverageQtdAbandoned}
                  />
                  <CardSimple title="NPS" value="67 NPS" width="middle" />
                  <CardSimple title="CSAT" value="75%" width="middle" />
                  <CardStatusOperators
                    classname="operator-in-analitic-view-2 responsive__item"
                    title="Status dos Operadores"
                  />
                </div>
                <div className="manager-container__row-two responsive">
                  <CardPerfomance title="Desempenho do(s) serviço(s)" />
                  <CardPreferredIntentions
                    classname="preferred-intentions"
                    title="Intenções Preferidas"
                  />
                </div>
                <div className="manager-container__row-three small responsive">
                  <div className="manager-container__row-three-small-responsive__cards-one">
                    <CardQueue
                      timeOfAverage={timeOfAverage}
                      title="Tempo de Espera"
                      queue="time-queue"
                      clientQueueMax={[]}
                    />
                    <CardAbandonment
                      level={timeAveragePercentAbandoned}
                      timeOfAbandoned={timeOfAbandoned}
                      title="Taxa de Abandono"
                      timeAverageQtdAbandoned={timeAverageQtdAbandoned}
                      width="middle"
                    />
                  </div>
                  <CardQueue
                    classname="clients-in-queue"
                    title="Clientes em Fila:"
                    queue="client-queue"
                    clientQueueMax={jsonQueueMax}
                    qtdQueue={
                      QueueReducer.filter((queue) => queue.status === "1")
                        .length
                    }
                  />
                </div>
                <div className="manager-container__row-four">
                  {modeScreen === "services" && (
                    <CardTableService
                      title="Todos os Serviços"
                      data={jsonSRV}
                    />
                  )}
                  {modeScreen === "teams" && (
                    <CardTableColaborator title="Colaboradores" />
                  )}
                </div>
              </div>
            )}
            {mode === 2 && (
              <div className="manager-container__area responsive">
                <CardLevelProgress
                  title="Nível de Serviço"
                  level={valorNSFinal}
                />
                <div className="manager-container__row-one responsive">
                  <CardClientAnswer
                    classname="interations-graph responsive__item"
                    title="Interações"
                    timeAverageMidleAnswer={timeAverageMidleAnswer}
                    level={Math.round(valorCAFinal)}
                    desempenhoRec={desempenhoRec}
                    atendidas={atendidas}
                    timeAverageQtdAbandoned={timeAverageQtdAbandoned}
                  />
                  <CardChannelVoz
                    classname="voice-interation-in-analitic-view-2 responsive__item"
                    title="Intenções no Canal de Voz"
                    media="voz"
                  />
                  <CardChannelDigital
                    classname="interation-in-analitic-view-2 responsive__item"
                    title="Intenções nos Canais Digitais"
                    media="digital"
                  />
                  <CardStatusOperators
                    classname="operator-in-analitic-view-2 responsive__item"
                    title="Status dos Operadores"
                  />
                </div>
                <div className="manager-container__row-two small responsive">
                  <CardPerfomance title="Desempenho do(s) serviço(s)" />
                  <div className="manager-container__row-two__small">
                    <CardQueue
                      classname="time-of-waiting"
                      timeOfAverage={timeOfAverage}
                      title="Tempo de Espera"
                      queue="time-queue"
                      clientQueueMax={[]}
                      width="small"
                    />
                    <CardAbandonment
                      classname="abandonment-rate"
                      level={timeAveragePercentAbandoned}
                      timeOfAbandoned={timeOfAbandoned}
                      title="Taxa de Abandono"
                      timeAverageQtdAbandoned={timeAverageQtdAbandoned}
                      width="small"
                    />
                  </div>
                </div>
                <div className="manager-container__row-three small responsive">
                  <div className="manager-container__row-three-small-responsive__cards-one">
                    <CardSimple title="NPS" value="67 NPS" width="small" />
                    <CardSimple title="CSAT" value="75%" width="small" />
                  </div>
                  <CardQueue
                    classname="clients-in-queue"
                    title="Clientes em Fila:"
                    queue="client-queue"
                    clientQueueMax={jsonQueueMax}
                    qtdQueue={
                      QueueReducer.filter((queue) => queue.status === "1")
                        .length
                    }
                    width="small"
                  />
                </div>
                <div className="manager-container__row-four responsive">
                  {modeScreen === "services" && (
                    <CardTableService
                      title="Todos os Serviços"
                      data={jsonSRV}
                    />
                  )}
                  {modeScreen === "teams" && (
                    <CardTableColaborator title="Colaboradores" />
                  )}
                </div>
              </div>
            )}
            {mode === 3 && (
              <div className="stage responsive">
                <div className="canvas">
                  <QueueSlim />
                  <Queue />
                  <Manager screen="new" />
                </div>
              </div>
            )}
            {mode === 4 && modeScreen === "teams" && (
              <div className="manager-container__area responsive-teams">
                <div className="manager-container__row-four responsive-teams">
                  <div className="manager-container__row-four__cards-info responsive-teams">
                    <CardTimeRow type={"row"} typeRow={"Voz"} />
                    <CardTimeRow type={"waiting"} typeRow={"Voz"} />
                    <CardTimeRow type={"row"} typeRow={"Digital"} />
                    <CardTimeRow type={"waiting"} typeRow={"Digital"} />
                  </div>
                  <CardTableGroupRow title={"Acompanhamento Grupos de Filas"} />
                </div>
                <CardTotalConnected
                  title1="Conectados"
                  title2="Inativos"
                  level={valorNSFinal}
                />

                <div className="manager-container__row-five responsive">
                  <CardTableOperatorsManager
                    title={"Painel Acompanhamento Atendentes"}
                  />
                </div>
              </div>
            )}
          </>
        )}
        <Drawer
          isOpen={isVisibleDrawer}
          setCloseDrawer={this.setVisibleDrawer}
          bind={this}
          screen="manager"
          title="Filtros Dashboard"
        />
        <div className="canvas__wrapper__footer">
          <div className="block transparent active-chats" id="active-chats">
            <div className="active-chats__tabs">
              <ul className="active-chats__list">
                <ChatSimultComponent
                  chatemcurso={[]}
                  remotescreen={"manager"}
                />
              </ul>
            </div>
          </div>
        </div>
        <input type="hidden" id="simulation_click" name="simulation_click" />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ManagerNew);
